import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

let router = new VueRouter({
  mode: 'history',
  base: '/',
  routes: [{
      path: '/',
      name: '首頁',
      component: Home
    },
    {
      path: '/about',
      name: '關於銳仕',
      component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
      path: '/support',
      name: '客服中心',
      component: () => import( /* webpackChunkName: "support" */ '../views/Support.vue')
    },
    {
      path: '/contact',
      name: '聯絡我們',
      component: () => import( /* webpackChunkName: "contact" */ '../views/Contact.vue')
    },
    {
      path: '/search_order',
      name: '訂單查詢',
      component: () => import( /* webpackChunkName: "search_order" */ '../views/SearchOrder.vue')
    },
    {
      path: '/dealer',
      name: '全台經銷',
      component: () => import( /* webpackChunkName: "findus" */ '../views/Findus.vue')
    },
    {
      path: '/payerror',
      name: '錯誤頁面',
      component: () => import( /* webpackChunkName: "payerror" */ '../views/PayError.vue')
    },
    {
      path: '/order_create',
      name: '訂單建立',
      component: () => import( /* webpackChunkName: "order_create" */ '../views/Order.vue')
    },
    {
      path: '/ship_doc',
      name: '退換貨政策',
      component: () => import( /* webpackChunkName: "ship_doc" */ '../views/ShipDoc.vue')
    },
    {
      path: '/product/list/:type',
      name: '產品列表',
      component: () => import( /* webpackChunkName: "product_list" */ '../views/ProductList.vue')
    },
    {
      path: '/product/:id',
      name: '商品介紹',
      component: () => import( /* webpackChunkName: "product_detail" */ '../views/ProductDetail.vue')
    },
    {
      path: '/news/list',
      name: '最新消息',
      component: () => import( /* webpackChunkName: "news_list" */ '../views/NewsList.vue')
    },
    {
      path: '/video/list',
      name: '影音相簿',
      component: () => import( /* webpackChunkName: "video_gallery" */ '../views/VideoGallery.vue')
    },
    {
      path: '/video/:id',
      name: '影音內容',
      component: () => import( /* webpackChunkName: "video_page" */ '../views/VideoPage.vue')
    },
    {
      path: '/news/:id',
      name: '新聞內容',
      component: () => import( /* webpackChunkName: "news_page" */ '../views/NewsPage.vue')
    },
    {
      path: '/checkout',
      name: '結帳',
      component: () => import( /* webpackChunkName: "checkout" */ '../views/CheckOut.vue')
    },
    {
      path: '/checkout_result/:type',
      name: '訂單結果',
      component: () => import( /* webpackChunkName: "checkout_result" */ '../views/CheckOutResult.vue')
    },
    {
      path: '/index.html',
      redirect: '/',
    },
    {
      path: '/home',
      redirect: '/',
    },
    {
      path: '/index.php',
      name: 'BotHome',
      component: Home
    },
    {
      path: '/error_page',
      name: '404Page',
      component: () => import( /* webpackChunkName: "404Page" */ '../views/404Page.vue')
    },
    // 舊頁面轉址
    {
      path: '/product/list/all/1',
      redirect: "/product/list/all"
    },
    {
      path: '/news/list/1',
      redirect: "/news/list"
    },
    {
      path: '/video/list/1',
      redirect: "/video/list"
    },
    {
      path: '*',
      redirect: "/error_page"
    }
  ],
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }
})
export default router;